import { __assign, __extends } from "tslib";
import React from 'react';
import * as Actions from '../redux/actions/actions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PnmacUIButton, PnmacTextInput } from 'pnmac-universal-components';
var EmailVerification = /** @class */function (_super) {
  __extends(EmailVerification, _super);
  function EmailVerification(props) {
    var _this = _super.call(this, props) || this;
    _this.requestVerification = function () {
      fetch("/api/main/check_verify_email?ssn=".concat(_this.state.ssn, "&&verificationGuid=").concat(_this.state.verificationGuid), {
        method: "GET"
      }).then(function (d) {
        return d.json();
      }).then(function (d) {
        _this.setState({
          emailVerificationStatus: d
        });
        //if (!d) {
        //    this.setState({ error: true, lastFourError: true })
        //} else {
        //    this.setState({ error: false, lastFourError: false, success: true })
        //}
      });
    };
    _this.state = {
      ssn: "",
      verificationGuid: props.match.params.verify,
      error: false,
      lastFourError: false,
      success: false,
      emailVerificationStatus: -1
    };
    return _this;
  }
  EmailVerification.prototype.componentDidMount = function () {
    this.props.ui_data();
  };
  EmailVerification.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      translations = _b.translations,
      layout = _b.layout;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        margin: 20
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      alt: "Pennymac logo",
      style: {
        height: 50
      },
      src: layout.logoUrl
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 75
      }
    }, /*#__PURE__*/React.createElement("h2", null, translations === null || translations === void 0 ? void 0 : translations.EmailVerification)), this.state.emailVerificationStatus == 0 && /*#__PURE__*/React.createElement("div", null, translations === null || translations === void 0 ? void 0 : translations.EmailUpdatedSuccessfully), this.state.emailVerificationStatus == 1 && /*#__PURE__*/React.createElement("div", null, translations === null || translations === void 0 ? void 0 : translations.EmailUpdatationFailed), this.state.emailVerificationStatus == 2 && /*#__PURE__*/React.createElement("div", null, translations === null || translations === void 0 ? void 0 : translations.EmailUpdationCountsExceeded), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      id: "desDiv"
    }, translations === null || translations === void 0 ? void 0 : translations.EmailVerificationDescription), /*#__PURE__*/React.createElement("div", {
      id: "mainDiv"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, translations === null || translations === void 0 ? void 0 : translations.EnetrLastFourSSN), /*#__PURE__*/React.createElement(PnmacTextInput, {
      style: {
        margin: 20,
        width: '80%',
        outline: 'none',
        border: 'unset',
        backgroundColor: 'unset'
      },
      label: this.state.lastFourError ? 'Please enter the last 4 digits of your Social Security Number' : 'Last 4 Digits of SSN',
      value: this.state.ssn,
      maxLength: 4,
      error: this.state.lastFourError,
      onChangeText: function (text) {
        _this.setState({
          ssn: text
        });
      }
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, translations === null || translations === void 0 ? void 0 : translations.PageExpiresIn24Hrs), /*#__PURE__*/React.createElement("div", {
      id: "buttonRow"
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      style: {
        backgroundColor: "#d6e6f4"
      },
      disabled: ((_a = this.state.ssn) === null || _a === void 0 ? void 0 : _a.length) <= 0,
      onClick: function () {
        _this.requestVerification();
      }
    }, "Submit")))))));
  };
  return EmailVerification;
}(React.PureComponent);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);